import React, { useState } from 'react';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Box,
  TextField,
  Snackbar,
  CircularProgress,
  IconButton,
  InputAdornment,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { Visibility } from '@material-ui/icons';
import { req } from '@omega-energia/react';
import { useAuth } from '../../../../../auth/authProvider';

export default function ModalAdicionarCampanha({ isOpen, onClose, refetch, refetchCampanha, id: partnerInvoiceId }) {
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useAuth();

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      name: '',
      partnerInvoiceId,
      amount: '',
    },
  });

  const closeAndResetForm = () => {
    reset({
      partnerInvoiceId,
      name: '',
      amount: '',
    });
    onClose();
  };

  const onSubmit = async data => {
    try {
      data.amount = UnMaskMoney(data.amount);
      setIsLoading(true);
      await req.post('/partner-invoice-campaigns', data, { token });
      setSnackbar({ open: true, message: 'Campanha adicionada à comissão com sucesso!' });
      setTimeout(() => {
        closeAndResetForm();
        if (refetch) {
          refetch();
        }
        if (refetchCampanha) {
          refetchCampanha();
        }
      }, 2000);
    } catch (error) {
      setSnackbar({ open: true, message: error?.message || 'Houve um erro ao adicionar a campanha' });
    } finally {
      setIsLoading(false);
    }
  };

  function UnMaskMoney(value) {
    if (typeof value === 'number') {
      return value;
    }
    const numericValue = value.replace(/\D/g, '');
    return numericValue ? parseFloat((parseInt(numericValue, 10) / 100).toFixed(2)) : 0;
  }

  function MoneyMask(value) {
    if (typeof value === 'number') {
      return value?.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    }

    const numericValue = value.replace(/\D/g, '');
    if (!numericValue) {
      return '';
    }

    const formatted = (parseInt(numericValue, 10) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    return formatted;
  }

  return (
    <>
      <Dialog open={isOpen} maxWidth="md">
        <DialogTitle>
          <Typography>Adicione um campanha à comissão</Typography>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box display="flex" flexDirection="column" mb={2}>
              <TextField
                variant="outlined"
                label="Nome da campanha"
                name="name"
                placeholder="Nome da campanha"
                {...register('name', {
                  required: 'Este campo é obrigatório',
                })}
                error={!!errors.name}
                helperText={errors.name?.message?.toString()}
              />
            </Box>
            <Box display="flex" flexDirection="column" mb={2}>
              <TextField
                variant="outlined"
                label="Valor Campanha"
                name="amount"
                placeholder="Digite o valor a ser adicionado"
                {...register('amount', {
                  required: 'Este campo é obrigatório',
                })}
                onChange={event => {
                  setValue('amount', MoneyMask(event.target.value));
                }}
                error={!!errors.amount}
                helperText={errors.amount?.message?.toString()}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        <Visibility />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <DialogActions>
              <Button type="button" onClick={() => closeAndResetForm()} color="primary" disabled={isLoading}>
                CANCELAR
              </Button>
              <Button type="submit" color="primary" disabled={isLoading || !isDirty} style={{ minWidth: '75px' }}>
                {isLoading ? <CircularProgress size={14} /> : 'SALVAR'}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        message={snackbar.message}
        onClose={() => setSnackbar({ open: false, message: '' })}
      />
    </>
  );
}
